import Vue from 'vue'
import VueRouter from 'vue-router'
import Subscribe from '../views/Subscribe.vue'
import ProblemReport from '../views/ProblemReport.vue'
import Deposit from '../views/Deposit.vue'
import ManageAccount from '../views/ManageAccount.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Subscribe',
    component: Subscribe
  },
  {
    path: '/problemreport',
    name: 'ProblemReport',
    component: ProblemReport
  },
  {
    path: '/deposit',
    name: 'Deposit',
    component: Deposit
  },
  {
    path: '/manageAccount',
    name: 'ManageAccount',
    component: ManageAccount
  },
  {
    path: '*',
    redirect: '/'
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
